import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {AdviserModel} from '@/models/adviserModel';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'advisers';

// @ts-ignore
if (store.state.advisers) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class AdvisersStoreModule extends EntityStateAdapter<AdviserModel> {

  get advisers(): AdviserModel[] {
    return this._entities;
  }

  @Action({commit: 'insertMany', rawError: true})
  fetchAll(challengeId: number): Promise<AdviserModel[]> {
    return (new ChallengesApi())
      .findAdvisers(challengeId)
      .pipe(take(1))
      .toPromise()
  }
}
